import { applyMiddleware, combineReducers } from "redux";
import createSagaMiddleware from "redux-saga";
import { all, fork } from "typed-redux-saga";
import { AppReducer, appSaga } from "./app";
import { AssetReducer, assetSaga } from "./asset";
import { AuthReducer, authSaga } from "./auth";
import { BannerReducer, bannerSaga } from "./banner";
import { CampaignReducer, campaignSaga } from "./campaign";
import { CouponReducer, couponSaga } from "./coupon";
import { ExternalReducer, externalSaga } from "./external";
import { MenuReducer, menuSaga } from "./menu";
import { OrderReducer, orderSaga } from "./order";
import { PaymentReducer, paymentSaga } from "./payment";
import { StoreReducer, storeSaga } from "./store";

const sagaMiddleware = createSagaMiddleware({});
export function runSaga() {
  sagaMiddleware.run(function* () {
    yield all([
      fork(appSaga),
      fork(assetSaga),
      fork(authSaga),
      fork(bannerSaga),
      fork(campaignSaga),
      fork(couponSaga),
      fork(externalSaga),
      fork(menuSaga),
      fork(orderSaga),
      fork(paymentSaga),
      fork(storeSaga),
    ]);
  });
}
export const middlewares = applyMiddleware(sagaMiddleware);

export const reducers = combineReducers({
  app: AppReducer,
  asset: AssetReducer,
  auth: AuthReducer,
  banner: BannerReducer,
  campaign: CampaignReducer,
  coupon: CouponReducer,
  external: ExternalReducer,
  menu: MenuReducer,
  order: OrderReducer,
  payment: PaymentReducer,
  store: StoreReducer,
});
